import React from 'react';
import { Calendar, Leaf, Star } from 'lucide-react';

const CriteriaSection = () => {
  const criteria = [
    {
      icon: Calendar,
      title: 'Established Track Record',
      description: 'Minimum 3 years of proven history on Amazon marketplace'
    },
    {
      icon: Leaf,
      title: 'Organic Strength',
      description: 'TACoS under 15%, displaying organic sales strength.'
    },
    {
      icon: Star,
      title: 'Product-Market Love',
      description: '4+ star customer reviews that show genuine product love'
    }
  ];

  return (
    <section id="what-we-buy" className="py-24 md:py-32 bg-[#F5F0EB] px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <h2 
          className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1B4D3E] mb-20"
          style={{fontFamily: 'Space Grotesk, sans-serif'}}
        >
          We like to buy businesses with:
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {criteria.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="bg-white p-10 rounded-lg shadow-sm hover:shadow-md transition-shadow"
              >
                <Icon className="w-12 h-12 text-[#1B4D3E] mb-6" strokeWidth={2} />
                <h3 
                  className="text-2xl font-bold text-[#1B4D3E] mb-4"
                  style={{fontFamily: 'Space Grotesk, sans-serif'}}
                >
                  {item.title}
                </h3>
                <p className="text-lg text-[#2C2C2C] leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CriteriaSection;